import React from "react";
import BannerHero from "@/components/bannerHero";
import AboutLayout from "@/components/layout/AboutLayout";
import AboutWelcome from "@/components/about/aboutWelcome";

const HeadteacherWelcome = () => {
    return (
        <>
            <BannerHero
                title="Welcome"
                bgImage="/images/about_cayman.webp"
                className="about-cayman"
            />
            <AboutLayout>
                <AboutWelcome />
            </AboutLayout>
        </>
    );
};

export default HeadteacherWelcome;
